import { Address, CreateAddress, UpdateAddress } from "../../Models/Address";
import { GetByCustomer } from "../../Models/ProductCategoryDiscount";
import api from "../axios";

export const addressService = {
  getByCustomer: async (data: GetByCustomer): Promise<Address[]> => {
    const response = await api.post('/address/by-customer/', data);
    return response.data;
  },
  
  create: async (data: CreateAddress): Promise<string | null> => {
    const response = await api.post('/address', data);
    return response.data;
  },

  update: async (data: UpdateAddress): Promise<boolean> => {
    const response = await api.patch('/address', data);
    return response.data;
  },

  delete: async (id: string): Promise<boolean> => {
    const response = await api.delete(`/address/${id}`);
    return response.data;
  }
};
